import styled from 'styled-components';
import { headingStyles } from '../styles';
var H1 = /*#__PURE__*/styled.h1.withConfig({
  displayName: "H1",
  componentId: "sc-11l15yc-0"
})(["", ";font-size:", ";"], headingStyles, function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.fontSize.ft40;
});
H1.displayName = 'H1';
export default H1;